import { SiteUrls } from '@tableau/shared-urls';

import { Module } from '../../ts/Module';
import { IWorkbookRevision } from '../serverApi/types/IWorkbookRevision';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { WindowLocationService } from '../../commonInfra/services/WindowLocationService';

export class PreviewWorkbookRevisionAction {


  public openPreview(revision: IWorkbookRevision) {
    const siteUrls = new SiteUrls({siteUrlName: getSessionManagementServiceInstance().sessionSiteUrlName(), queryString: window.location.search});
    WindowLocationService.open(siteUrls.workbookRevisionPreviewUrl(revision.revisionPath));
  }

}

Module.instance().service('PreviewWorkbookRevisionAction', PreviewWorkbookRevisionAction);
